import {Service} from "@/services/superclasses/service";
import {UploadStatus} from "@/interfaces/upload-status";

const api = window.contextPath;

export class FileService extends Service {

    public copy = async (id: number, code: string): Promise<UploadStatus> => {
        return this.data(await this.post<UploadStatus>(api + "/CopyServlet?id=" + id + "&code=" + code))
    }
}

export const fileService = new FileService()